import React from 'react';
// import TopHeader from './TopHeader';
import { Container } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router';
import { NavLink } from "react-router-dom";
// import logoWhite from '../../../logo-white.svg';
import Image from '../../atoms/Image/Image';
import logoDark from '../../../logo.svg';
import { useAuth } from '../../../context/AuthContext';

const Header = () => {
    const { isAuthenticated, logout } = useAuth();
    // const location = useLocation();
    // const isHomePage = location.pathname === '/';
    const headerClass = 'header-main inner-header';
    const logo = logoDark;
    const menuItems = [
        { label: 'Home', path: '/' },
        { label: 'About', path: '/about' },
        { label: 'Contact', path: '/contact' },
        // { label: 'Search', path: '/search-result' },

    ];
    const authItems = isAuthenticated
        ? [
            // { label: 'Dashboard', path: '/dashboard' },
            { label: 'Logout', action: logout },
        ]
        : [
            { label: 'Login', path: '/login' },
            { label: 'Register', path: '/register' },
        ];


    return (
        <>
            <div className={headerClass}>
                <header className='header'>
                    <Navbar expand="lg" >
                        <Container>
                            <Link to="/"><Image src={logo} alt="logo" width="" height="" /></Link>
                            <Navbar.Toggle aria-controls="basicNavbarNav" />
                            <Navbar.Collapse id="basicNavbarNav" className="headerMenu">
                                <ul className="ms-auto header--menu">
                                    {menuItems.map((item, index) => (
                                        <li key={index}>
                                            <NavLink
                                                to={item.path}
                                                className={({ isActive }) => isActive ? "active" : ""}
                                            >
                                                {item.label}
                                            </NavLink>
                                        </li>
                                    ))}

                                    {authItems.map((item, index) => (
                                        <li key={`auth-${index}`}>
                                            {item.path ? (
                                                <NavLink
                                                    to={item.path}
                                                    className={({ isActive }) => isActive ? "active" : ""}
                                                >
                                                    {item.label}
                                                </NavLink>
                                            ) : (
                                                <button onClick={item.action} className="header--menu-button">
                                                    {item.label}
                                                </button>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </header>
            </div>
        </>
    )
}
export default Header